import { Helpers } from '../../helpers';
import { IDrillDesign } from '../../interfaces/idrill-design';
import { AssetTeam } from '../asset-team';
import { BatchProcessType } from '../batch-process-type';
import { DrillGroup } from '../drill-group';
import { Equation } from '../equation';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { ProjectTemplate } from '../project-template';
import { ScheduleBuildSetting } from '../schedule-build-setting';
import { Well } from '../well';

export class DrillDesignBase {
  DrillDesignId: number;
  Name: string;
  Alias: string | null;
  AssetTeamId: number | null;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;
  SysStartTime: Date;
  SysEndTime: Date;

  BatchProcessTypes_DrillDesign?: Array<BatchProcessType> | null;
  DrillGroups_DrillDesign?: Array<DrillGroup> | null;
  Equations_DrillDesign?: Array<Equation> | null;
  ProjectDrillingParameters_DrillDesign?: Array<ProjectDrillingParameter> | null;
  ProjectTemplates_DrillDesign?: Array<ProjectTemplate> | null;
  Wells_DrillDesign?: Array<Well> | null;
  ScheduleBuildSettings_DefaultDrillType?: Array<ScheduleBuildSetting> | null;
  Wells_StandardDrillDesign?: Array<Well> | null;
  AssetTeam?: AssetTeam;

  constructor(item?: IDrillDesign) {
    if (item) {

      this.DrillDesignId = item.DrillDesignId;
      this.Name = item.Name;
      this.Alias = item.Alias;
      this.AssetTeamId = item.AssetTeamId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;

      this.BatchProcessTypes_DrillDesign = Helpers.createClassArray(BatchProcessType, item.BatchProcessTypes_DrillDesign);
      this.DrillGroups_DrillDesign = Helpers.createClassArray(DrillGroup, item.DrillGroups_DrillDesign);
      this.Equations_DrillDesign = Helpers.createClassArray(Equation, item.Equations_DrillDesign);
      this.ProjectDrillingParameters_DrillDesign = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_DrillDesign);
      this.ProjectTemplates_DrillDesign = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_DrillDesign);
      this.Wells_DrillDesign = Helpers.createClassArray(Well, item.Wells_DrillDesign);
      this.ScheduleBuildSettings_DefaultDrillType = Helpers.createClassArray(ScheduleBuildSetting, item.ScheduleBuildSettings_DefaultDrillType);
      this.Wells_StandardDrillDesign = Helpers.createClassArray(Well, item.Wells_StandardDrillDesign);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
    }
  }
}